// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Place$LumiDocuments from "./Place.res.js";
import * as Types$LumiDocuments from "./Types.res.js";
import * as PlaceClass$LumiDocuments from "./PlaceClass.res.js";
import * as SensorGroups$LumiStaticData from "lumi-static-data/lib/es6/src/SensorGroups.res.js";
import * as UltrasonicSensor$LumiDocuments from "./UltrasonicSensor.res.js";

let jsonCodec = Jzon.object2(param => [
  param.capacity,
  param.modbusTcpConverter
], param => ({
  TAG: "Ok",
  _0: {
    capacity: param[0],
    modbusTcpConverter: param[1]
  }
}), Jzon.field("capacity", Jzon.int), Jzon.field("modbusTcpConverter", Document$LumiStore.Key.jsonCodec()));

let StJansdalRoofSensor = {
  jsonCodec: jsonCodec
};

let jsonCodec$1 = LumiJzon.taggedVariantOptionalContents(value => {
  if (typeof value !== "object") {
    return [
      "ManagedSensorType",
      undefined
    ];
  }
  switch (value.TAG) {
    case "PlaceSensorType" :
      return [
        "PlaceSensorType",
        Jzon.encodeWith(value._0, Place$LumiDocuments.Place.jsonCodec)
      ];
    case "UltrasonicSensorType" :
      return [
        "UltrasonicSensorType",
        Jzon.encodeWith(value._0, UltrasonicSensor$LumiDocuments.UltrasonicSensor.jsonCodec)
      ];
    case "StJansdalRoofSensorType" :
      return [
        "StJansdalRoofSensorType",
        Jzon.encodeWith(value._0, jsonCodec)
      ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "ManagedSensorType" :
      return {
        TAG: "Ok",
        _0: "ManagedSensorType"
      };
    case "PlaceSensorType" :
      return Stdlib_Result.map(Stdlib_Result.flatMap(LumiOption.okOr(json, {
        NAME: "UnexpectedJsonValue",
        VAL: [
          [],
          "content missing"
        ]
      }), __x => Jzon.decode(Place$LumiDocuments.Place.jsonCodec, __x)), place => ({
        TAG: "PlaceSensorType",
        _0: place
      }));
    case "StJansdalRoofSensorType" :
      return Stdlib_Result.map(Stdlib_Result.flatMap(LumiOption.okOr(json, {
        NAME: "UnexpectedJsonValue",
        VAL: [
          [],
          "content missing"
        ]
      }), __x => Jzon.decode(jsonCodec, __x)), stJansdalRoofSensor => ({
        TAG: "StJansdalRoofSensorType",
        _0: stJansdalRoofSensor
      }));
    case "UltrasonicSensorType" :
      return Stdlib_Result.map(Stdlib_Result.flatMap(LumiOption.okOr(json, {
        NAME: "UnexpectedJsonValue",
        VAL: [
          [],
          "content missing"
        ]
      }), __x => Jzon.decode(UltrasonicSensor$LumiDocuments.UltrasonicSensor.jsonCodec, __x)), ultrasonicSensor => ({
        TAG: "UltrasonicSensorType",
        _0: ultrasonicSensor
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

function asPlace(sensorSubType) {
  if (typeof sensorSubType !== "object" || sensorSubType.TAG !== "PlaceSensorType") {
    return;
  } else {
    return sensorSubType._0;
  }
}

function mapPlace(sensorSubType, updatePlace) {
  if (typeof sensorSubType !== "object" || sensorSubType.TAG !== "PlaceSensorType") {
    return sensorSubType;
  } else {
    return {
      TAG: "PlaceSensorType",
      _0: updatePlace(sensorSubType._0)
    };
  }
}

let SensorSubType = {
  jsonCodec: jsonCodec$1,
  asPlace: asPlace,
  mapPlace: mapPlace
};

let jsonCodec$2 = Jzon.object6(param => [
  param.name,
  param.description,
  param.placeClass,
  param.subType,
  param.centralId,
  param.measurementOverride
], param => ({
  TAG: "Ok",
  _0: {
    name: param[0],
    description: param[1],
    placeClass: param[2],
    subType: param[3],
    centralId: param[4],
    measurementOverride: param[5]
  }
}), Jzon.field("name", Jzon.string), Jzon.field("description", Jzon.string), Jzon.field("placeClass", PlaceClass$LumiDocuments.PlaceClass.jsonCodec), Jzon.field("subType", jsonCodec$1), Jzon.field("centralId", SensorGroups$LumiStaticData.SensorFullId.jsonCodec), Jzon.field("measurementOverride", Jzon.nullable(Types$LumiDocuments.SensorMeasurement.jsonCodec)));

function asPlace$1(sensor) {
  return asPlace(sensor.subType);
}

function mapPlace$1(sensor, updatePlace) {
  return {
    name: sensor.name,
    description: sensor.description,
    placeClass: sensor.placeClass,
    subType: mapPlace(sensor.subType, updatePlace),
    centralId: sensor.centralId,
    measurementOverride: sensor.measurementOverride
  };
}

let Sensor = {
  jsonCodec: jsonCodec$2,
  asPlace: asPlace$1,
  mapPlace: mapPlace$1
};

function documentName(param) {
  return param.name;
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "sensor",
  jsonCodec: jsonCodec$2,
  icon: "chart-line",
  readOnly: false
});

export {
  StJansdalRoofSensor,
  SensorSubType,
  Sensor,
  Schema,
}
/* jsonCodec Not a pure module */
